export function isDayModifiable(day) {
  if (!day?.HasMealsOrProducts && !day?.Config?.CanAddDays) {
    return false;
  }

  return areDayMealsModifiable(day?.Config) || areDayProductsModifiable(day?.Config);
}

export function areDayMealsModifiable(dayConfig) {
  return dayConfig?.CanChooseMeals && (dayConfig?.CanAddMeals || dayConfig?.CanRemoveMeals);
}

export function areDayProductsModifiable(dayConfig) {
  return dayConfig?.CanAddProducts || dayConfig?.CanRemoveProducts;
}
